export const EVENTS_PAGE_TABS = {
  NOW: 'now',
  UPCOMING: 'upcoming',
  PAST: 'past',
} as const;

export type EventPageTab = (typeof EVENTS_PAGE_TABS)[keyof typeof EVENTS_PAGE_TABS];
